<template>
    <aside class="tile tile-blur">
        <button
            class="flex w-full cursor-pointer items-center justify-between text-left text-lg leading-6 lg:cursor-auto"
            :aria-expanded="isOpen"
            aria-controls="about-dev"
            @click="toggleAccordion()">
            <div class="title flex-1">
                {{ data.title }}
            </div>
            <SvgComponent
                icon="chevron-down"
                class="w-4 transition-transform duration-300 lg:hidden"
                :class="{ 'rotate-180': isOpen }" />
        </button>
        <div
            id="about-dev"
            class="grid grid-rows-[0fr] overflow-hidden transition-[grid-template-rows] duration-300 group-last-of-type:pb-0"
            :class="{ 'grid-rows-[1fr]': isOpen || breakpoints[viewport] >= breakpoints.lg }"
            role="region">
            <div class="overflow-hidden">
                <div class="my-4 overflow-hidden text-base">
                    <div class="font-semibold">{{ data.vendorName }}</div>
                    <div v-html="data.body" />
                </div>
            </div>
        </div>
    </aside>
</template>
<script lang="ts" setup>
import type { VendorInfo } from '@su4r-frontend/api';
defineProps<{
    data: VendorInfo;
}>();

const { viewport, breakpoints } = useViewport();

const isOpen = ref<boolean>(false);
const toggleAccordion = (): void => {
    isOpen.value = !isOpen.value;
};
</script>
